<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >

    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-download"
            font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>

  <b-card
    title="مدیریت سفارش ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="4">
                <b-form-group
                  label="نوع"
                  label-for="DietType"
                >
                  <v-select
                    v-model="filterOptions.DietType"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    :multiple="true"
                    :options="enums('DietType')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="دوره"
                  label-for="DietDurationId"
                >
                  <z-diet-duration
                    v-model="filterOptions.DietDurationId"
                    :clearable="true"
                    :multiple="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="بانک"
                  label-for="Bank"
                >
                  <v-select
                    v-model="filterOptions.Bank"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    :multiple="true"
                    :options="enums('bank')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="کد پیگیری" label-for="Code">
                  <b-form-input v-model="filterOptions.Code" />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="کوپن"
                    label-for="CouponId"
                >
                  <z-coupon
                      v-model="filterOptions.CouponId"
                      :clearable="true"
                      :multiple="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <label>پرداخت</label>
                  <v-select
                    v-model="filterOptions.IsPaid"
                    :options="enums('IsPaid')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="محل پرداخت"
                    label-for="paymentPlace"
                >
                  <v-select
                      v-model="filterOptions.IsFromWeb"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      :options="enums('paymentPlace')"
                  />
                </b-form-group>
              </b-col>
<!--              <b-col md="2">-->
<!--                <b-form-group>-->
<!--                  <label>وضعیت</label>-->
<!--                  <v-select-->
<!--                      v-model="filterOptions.Status"-->
<!--                      :options="enums('Status')"-->
<!--                      dir="rtl"-->
<!--                      label="text"-->
<!--                      :reduce="x => x.value"-->
<!--                  />-->
<!--                </b-form-group>-->
<!--              </b-col>-->
              <b-col md="3">
                <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      type="datetime"
                      display-format="jYYYY/jMM/jDD HH:mm"
                      format="YYYY-MM-DD HH:mm"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      type="datetime"
                      display-format="jYYYY/jMM/jDD HH:mm"
                      format="YYYY-MM-DD HH:mm"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="موبایل"
                    label-for="Mobile"
                >
                  <b-form-input
                      v-model="filterOptions.Mobile"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="وضعیت تایید حسابداری"
                >
                  <v-select
                      v-model="filterOptions.NeedConfirmed"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      :options="[
                              { text: 'تایید شده', value: false },
                              { text: 'تایید نشده', value: true },
                              { text: 'هیچکدام', value: null },
                      ]"
                  />
                </b-form-group>
              </b-col>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
              <b-button
                  variant="gradient-secondary"
                  class="mb-1 mr-1"
                  @click="exportExcel()"
              >خروجی اکسل
              </b-button>
              <b-button
                  variant="gradient-secondary"
                  class="mb-1 mr-1"
                  @click="exportNotPaidExcel()"
              >خروجی اکسل پرداخت نشده
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          :busy="loading"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatediscount', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(DietDurationPrice)="data">
            {{ data.value.Diet.Title }} {{ data.value.DietDuration.Title }}
          </template>

          <template #cell(Bank)="data">
            {{ enums('bank', 'value', data.value, 'text') }}
          </template>
          <template #cell(InCallQueue)="data">
            <feather-icon v-if="data.value" class="mr-1" icon="CheckSquareIcon" size="20" />
            <feather-icon v-else  class="mr-1" icon="SquareIcon" size="20" />
          </template>
          <template #cell(Coupon)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(User)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
              <b-media
                vertical-align="center"
                style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                    :src="data.value.Image"
                  />
                </template>
                <span
                  class="font-weight-bold d-block text-nowrap"
                  style="color: #6e6b7b;"
                >
                  <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.value.Id }}</small>
              </b-media>
            </b-link>
          </template>

          <template #cell(IsPaid)="data">
            <b-badge
                v-if="data.item.IsPaid"
              variant="success"
            >
           پرداخت شده
            </b-badge>
            <b-badge
                v-else
                variant="warning"
                @click="showModal(data.item)"
            >
               پرداخت نشده
            </b-badge>
          </template>

          <template #cell(Status)="data">
            <b-badge
                v-if="data.item.Status !== null"
                @click="openSidebar(data.item)"
                :variant="enums('Status', 'value', data.value, 'badge')"
            >
              {{ enums('Status', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date('date-time') }}
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #cell(IsFromWeb)="data">
            {{ data.value ? 'پرداخت وب' : 'پرداخت اپ' }}
          </template>
          <template #cell(actions)="data">
            <div v-if="data.item.NeedConfirmed">
              <b-spinner small v-if="loadNeedConfirmed===data.item.Id" />
              <feather-icon
                  v-else
                  icon="SettingsIcon"
                  size="16"
                  @click="getNeedConfirmed(data)"
              />
            </div>

          </template>
              <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <z-user-diet-order-details v-if="isSidebarOpen" @close="isSidebarOpen = false" :obj="userDietOrderDetails" />
  </b-card>

    <b-modal
        v-model="isShow"
        v-if="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        modal-class="confirm-pay-modal"
        title="تایید پرداخت"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="confirmPay"
    >
      <div>
        پرداخت مورد نظر تایید شود؟
      </div>
    </b-modal>

     <b-modal
        v-model="showNeedConfirmed"
        v-if="showNeedConfirmed"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        size="lg"
        modal-class="w-32"
        title="تایید پرداخت"
        @close="needConfirmedInfo={}"
        hide-footer
    >
       <b-alert show variant="warning" class="p-2 text-center">
         پرداخت با مشخصات زیر تایید شود؟
       </b-alert>
       <div>
         <p>
           مدت رژیم:
           {{needConfirmedInfo.Order.DietDuration}}
         </p>
         <p>
           نوع رژیم:
           {{needConfirmedInfo.Order.DietTypeText}}
         </p>
<p>
نوع پرداخت:
           {{needConfirmedInfo.Order.PaymentType}}
         </p>
         <p>
قیمت:
           {{needConfirmedInfo.Order.Price}}
         </p>
         <b-table
             bordered
             hover
             striped
             :items="needConfirmedInfo.OrderDetails"
             :fields="needConfirmedInfo.fields"
             responsive
         >
           <template #cell(CreatedAt)="data">
             {{ data.value | date('date-time') }}
           </template>
<template #cell(AttacheFile)="data">
    <a :href="data.value" target="_blank">مشاهده</a>
           </template>

         </b-table>
       </div>
       <b-button @click="showRejectConfirm=true" variant="warning" class="float-right">رد</b-button>
       <b-button @click="showAllowConfirm=true " variant="success" class="float-left">تایید</b-button>

     </b-modal>
     //confirm
    <b-modal
        v-model="showAllowConfirm"
        cancel-title="انصراف"
        ok-title="تایید"
        cancel-variant="outline-secondary"
        centered
        size="sm"
        title="تایید پرداخت"
        @ok="confirmOrderThatNeedConfirm(true)"
    >
      <p>آیا مطمئن هستید برای تایید پرداخت</p>
    </b-modal>
     <b-modal
        v-model="showRejectConfirm"
        cancel-title="انصراف"
        ok-title="رد شود"
        cancel-variant="outline-secondary"
        centered
        size="sm"
        title="رد کردن پرداخت"
        @ok="confirmOrderThatNeedConfirm(false)"
    >
      <p>آیا مطمئن هستید برای رد کردن پرداخت</p>
    </b-modal>

  </b-overlay>
</template>

<script>

import { BIcon, BIconCloudDownload,BAlert } from 'bootstrap-vue'
import ZDietDuration from '@/tools/dietduration.vue'
import ZCoupon from '@/tools/coupon.vue'
import ZUserDietOrderDetails from '@/views/menu/order/userdietorderdetails.vue'

export default {
  name: 'UserDietOrder',
  components: {
    ZDietDuration,
    ZCoupon,
    ZUserDietOrderDetails,
    BIcon,
    BIconCloudDownload
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      processing: false,
      counter: 1,
      isShow: false,
      row: null,
      filterOptions: {
        Title: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
        IsPaid: null,
        DietDurationId: [],
        DietType: [],
        Bank: [],
        CouponId: [],
        Code: '',
        IsFromWeb: null,
        Mobile: null,
        FromDate: this.$moment().startOf('jMonth').format('YYYY-MM-DD HH:mm'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY-MM-DD HH:mm'),
        NeedConfirmed: null
      },
      isSidebarOpen: false,
      userDietOrderDetails: {
        DietDurationPrice: {Diet:{}, DietDuration:{}},
        Coupon: {}
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'DietDurationPrice',
          label: 'محصول',
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'Code',
          label: 'کد پیگیری',
          tdClass: 'col-width-15',
        },
        {
          key: 'Price',
          label: 'مبلغ',
          sortable: true,
        },
        {
          key: 'Coupon',
          label: 'تخفیف',
        },
        {
          key: 'InCallQueue',
          label: 'انتظار تماس',
        },
        {
          key: 'Bank',
          label: 'بانک',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
        {
          key: 'IsFromWeb',
          label: 'محل پرداخت'
        },
        {
          key: 'IsPaid',
          label: 'پرداخت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
        // {
        //   key: 'Status',
        //   label: 'وضعیت',
        // },
      ],
      items: [],
      showNeedConfirmed: false,
      needConfirmedInfo: {},
      loadNeedConfirmed:false,
      showAllowConfirm:false,
      showRejectConfirm:false
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.userdietorder.getlistInUserDietOrder, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openSidebar(data) {
      this.isSidebarOpen = true
      this.userDietOrderDetails = data
    },
    remove(id) {
      this.removeRow(this.$api.discount.remove, 'Id', id)
    },
    showModal(row){
         this.row = row
      this.isShow = true
    },
    confirmPay(){
      this.isShow = false
      this.$http.post(
          this.$api.userdietorder.confirmpay, {
            Id: this.row.Id,
          },
      )
          .then(res => {
            this.update()
          })
    },
    confirmOrderThatNeedConfirm(status){
      this.isShow = false
      this.$http.post(
          this.$api.userdietorder.confirmOrderThatNeedConfirm, {
            OrderId:this.needConfirmedInfo.Id,
            UserId:this.needConfirmedInfo.UserId,
            Confirmed:status
          },
      )
          .then(res => {
            this.showRejectConfirm = false
            this.showAllowConfirm = false
            this.showNeedConfirmed = false
            this.update()
          })
    },
    exportExcel(){
      var This = this
      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'UserDietOrder.xlsx'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("POST", '/api/userdietorder/export-excel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify(this.filterOptions))
    },
    exportNotPaidExcel(){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'UserDietOrderNotPaid.xlsx'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      let url = new URL(window.location.origin + '/api/userdietorder/export-excel-notpaid')
      url.searchParams.set('FromDate', this.$moment(this.filterOptions.FromDate).format('YYYY-MM-DD'));
      url.searchParams.set('ToDate', this.$moment(this.filterOptions.ToDate).format('YYYY-MM-DD'));
      xmlHttpRequest.open("GET", url)
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify(this.filterOptions))
    },
    getNeedConfirmed(data){
      this.loadNeedConfirmed = data.item.Id
      this.$http.post(
          this.$api.userdietorder.get, {
            OrderId:data.item.Id,
            UserId:data.item.User.Id
          },
      )
          .then(res => {
             this.needConfirmedInfo = res.data
             this.needConfirmedInfo.UserId = data.item.User.Id
             this.needConfirmedInfo.fields= [{
                key: 'CreatedAt',
                label: 'تاریخ',
                thClass: 'col-width-50',
             },
             {
                key: 'Description',
                label: 'توضیحات',
             },
              {
                key: 'StatusText',
                label: 'وضعیت',
             },
             {
                key: 'AttacheFile',
                label: 'فایل',
                thClass: 'col-width-50',
             },
             ]
             this.showNeedConfirmed = true
          })
          .finally(() => {
            this.loadNeedConfirmed = null
          })
    }
  },
}
</script>
